import { forwardRef, type Ref, type SVGProps } from "react";
const IconSquareFeetOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path fill="currentColor" d="M8 13.586V23h9.414Zm2 4.828L12.586 21H10Z" />
    <path
      fill="currentColor"
      d="m29.39 25.56-24-22.02a1.98 1.98 0 0 0-1.38-.56H4a2.005 2.005 0 0 0-2 2V28a1.003 1.003 0 0 0 1 1h25a1.99 1.99 0 0 0 2-2 1.92 1.92 0 0 0-.61-1.44M23 27v-1a1 1 0 0 0-2 0v1h-3v-1a1 1 0 0 0-2 0v1h-3v-1a1 1 0 0 0-2 0v1H8v-1a1 1 0 0 0-2 0v1H4l.01-22L28 27Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSquareFeetOutlineSVG);
ForwardRef.displayName = "IconSquareFeetOutline";
export { ForwardRef as IconSquareFeetOutline };
